export default __webpack_public_path__ + "static/media/lacareheaderlogo.10a070b1.png";